import { Bundle } from "../../../types";
import { Flex, Text, Box } from "@chakra-ui/react";
import { TimerBadge } from "../../cards/components/TimerBadge";
import { PriceDisplay } from "../../cards/components/PriceDisplay";
import { useBundlePricing } from "../../../hooks/useBundlePricing";
import { t } from "i18next";

export function BundlePurchaseData({
  bundle,
  alignItems = "start",
}: {
  bundle?: Bundle;
  alignItems?: "start" | "center";
}) {
  if (!bundle) return null;

  const userOwnsAllItems = bundle.user_owns_all_items;
  const totalItems = bundle.total_items || bundle.items?.length || 0;
  const totalPages = bundle.total_pages || 0;
  const { priceToUse, hasDiscount, discountPercentage } =
    useBundlePricing(bundle);

  return (
    <Flex flexDirection="column" alignItems={alignItems} gap={2}>
      {/* Timer Badge */}
      {bundle.expires_on && (
        <Box alignSelf="flex-start">
          <TimerBadge availableUntil={bundle.expires_on} />
        </Box>
      )}

      {/* Bundle Title */}
      <Text variant="modalTitle" color="white" fontSize="18px">
        {bundle.display_name}
      </Text>

      {/* Releases and Pages Count */}
      <Text variant="modalBody" fontSize="14px" color="neutral.400">
        {totalItems} {totalItems === 1 ? "release" : "releases"}
        {totalPages > 0 && ` • ${totalPages} pages`}
      </Text>

      {/* Discount Badge */}
      {hasDiscount && (
        <Box
          bg="success.700"
          color="neutral.white"
          px={2}
          py={1}
          borderRadius="4px"
          fontSize="12px"
          fontWeight="bold"
        >
          {t("components.slideInMenu.bundleDetails.discountOff", {
            discountPercentage,
          })}
        </Box>
      )}

      {/* Prices */}
      {!userOwnsAllItems && (
        <Box>
          <PriceDisplay
            price={priceToUse}
            originalPrice={hasDiscount ? bundle.price : undefined}
            hasDiscount={hasDiscount}
          />
        </Box>
      )}
    </Flex>
  );
}
